<script>
import { CdrLink } from '@rei/cedar';

export default {
  name: 'TableOfContents',
  components: {
    CdrLink,
  },
  props: {
    articleType: {
      type: String,
      required: false,
      default: null,
      validator: (obj) => ['Tested', 'Staff'].includes(obj),
    },
    contentBlocks: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    baseClassName: 'table-of-contents',
  }),
  computed: {
    productReviews() {
      return this.contentBlocks?.filter((z) => ['product-recommendations', 'product-recommendations-gendered'].includes(z.component))
        .map((x) => ({
          title: x.data.tagline,
          linkText: x.data.name,
          link: `#${x.id}`,
          badge: x.data.badge,
        }));
    },
  },
};
</script>

<template>
  <div
    :class="`${baseClassName}`"
  >
    <h2 :class="`${baseClassName}__title`">
      {{ articleType === 'Tested' ? 'Test Results' : 'Staff Picks' }}
    </h2>
    <p :class="`${baseClassName}__subtext`">
      Find our quick recommendations here or scroll down for the full reviews.
    </p>

    <ul :class="`${baseClassName}__list`">
      <li
        v-for="(block, index) in productReviews"
        :key="index"
        :class="`${baseClassName}__list-item`"
      >
        <strong v-if="block.badge">
          {{ block.title }}
          <span v-if="block.title">& </span>

          <cdr-link
            href="/learn/expert-advice/rei-editors-choice-awards.html"
          > REI Co-op Editor’s Choice Award Winner
          </cdr-link>
          <span>:</span>
        </strong>

        <cdr-link
          :href="block.link"
          target="_self"
        >
          {{ block.linkText }}
        </cdr-link>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
@import '../../../../style/common/editor-styles.scss';

$baseClassName: 'table-of-contents';

.#{$baseClassName} {
  font-size: 1.8rem;
  line-height: 3rem;

  &__title {
    @include cdr-text-heading-serif-strong-800;
    margin: 0.75em 0;
  }

  &__subtext {
    margin: 1em 0;
  }

  &__list {
    margin-bottom: 1.2rem;
    margin-left: 0.85rem;
  }

  &__list-item {
    margin-top: 0.8rem;

    strong {
      margin-right: 0.5rem;
    }
  }

}
</style>
